import {object, string} from 'yup'

import {TranslatorScope} from '../../../locale/types'

export const MEMBERSHIP_CANCEL_REASON_MAX_LENGTH = 1000

type Translate = (key: TranslatorScope, options?: Record<string, unknown>) => string

// The reason is required: 1 to 1000 characters after trimming.
export const getMembershipCancelReasonSchema = (l: Translate) =>
  object({
    reason: string()
      .trim()
      .required(l('membershipCancel_reasonRequired'))
      .max(
        MEMBERSHIP_CANCEL_REASON_MAX_LENGTH,
        l('membershipCancel_reasonTooLong', {max: MEMBERSHIP_CANCEL_REASON_MAX_LENGTH}),
      ),
  })
